import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface RemoveCouponFromCartMutationObject {
  mutation: {
    removeCouponFromCart: {
      __args: {
        input: {
          cart_id: string
          [key: string]: any
        }
      }
      [key: string]: any
    }
  }
}

export const removeCouponFromCartMutationObject: RemoveCouponFromCartMutationObject = {
  mutation: {
    removeCouponFromCart: {
      __args: {
        input: {
          cart_id: ''
        }
      }
    }
  }
}

interface RemoveCouponFromCartMutationInput {
  cartId: string
}

export type RemoveCouponFromCartMutation = (input: RemoveCouponFromCartMutationInput) => Promise<FetchResult<any>>

export const createRemoveCouponFromCartMutation = ({ getMutations, getQueries }: ServiceDependencies): RemoveCouponFromCartMutation => async ({ cartId }) => {
  const queries = getQueries()
  const mutation = getMutations().removeCouponFromCartMutation
  mutation.mutation.removeCouponFromCart.__args.input.cart_id = cartId
  mutation.mutation.removeCouponFromCart = {
    ...mutation.mutation.removeCouponFromCart,
    cart: {
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses, // TODO: implement `withSelectedShippingMethod (selected_shipping_method)` and remove the ignore: true
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
